function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import styled from "styled-components";
export const ButtonHoC = PassedComponent => /*#__PURE__*/forwardRef((props, ref) => (({
  disabled,
  onClick,
  iconLeft,
  iconRight,
  children,
  forwardRef,
  ...props
}) => /*#__PURE__*/React.createElement(PassedComponent, _extends({
  disabled: disabled,
  onClick: disabled ? undefined : onClick,
  type: "button"
}, props, {
  ref: forwardRef
}), iconLeft && /*#__PURE__*/React.createElement(IconLeftContainer, null, iconLeft), children, iconRight && /*#__PURE__*/React.createElement(IconRightContainer, null, iconRight)))({ ...props,
  forwardRef: ref
}));
const IconContainer = styled.div`
  align-items: center;
  display: flex;
  height: 20px;
`;
const IconLeftContainer = styled(IconContainer)`
  margin-right: 8px;
`;
const IconRightContainer = styled(IconContainer)`
  margin-left: 8px;
`;